import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';

@Component({
    selector: 'keywords',
    templateUrl: './keywords.component.html',
    styleUrls: ['./keywords.component.scss'],
    standalone: false
})
export class KeywordsComponent implements OnInit {
    @Input() data: any;
    keywords = [];
    keywordList = [
        { code: 'bea', icon: 'icon-beach_location_close', name: 'Direkt am Strand' },
        { code: 'ben', icon: 'icon-beach_location_far', name: 'Strandnah' },
        { code: 'chf', icon: 'icon-child_friendly', name: 'Kinderfreundlich' },
        { code: 'ecc', icon: 'icon-babysitter', name: 'Kinderbetreuung' },
        { code: 'eec', icon: 'icon-child_programm', name: 'Unterhaltungsprogramm (Kinder)' },
        { code: 'emd', icon: 'icon-minidisco', name: 'Mini-Disco' },
        { code: 'emc', icon: 'icon-child_miniclub', name: 'Miniclub' },
        { code: 'fbs', icon: 'icon-babysitter', name: 'Babysitter' },
        { code: 'fcp', icon: 'icon-pool_child', name: 'Kinderpool' },
        { code: 'fpg', icon: 'icon-child_playground', name: 'Spielplatz' },
        { code: 'fpr', icon: 'icon-child_room', name: 'Spielzimmer' },
        { code: 'mcm', icon: 'icon-child_menu', name: 'Kindermenüs' },
        { code: 'rcb', icon: 'icon-child_cot', name: 'Kinderbett' },
        { code: 'hca', icon: 'icon-child_seat', name: 'Kinderhochstuhl' },
        { code: 'ani', icon: 'icon-animation', name: 'Animation' },
        { code: 'clb', icon: 'icon-club_hotel', name: 'Club' },
        { code: 'spt', icon: 'icon-sport', name: 'Sport' },
        { code: 'sws', icon: 'icon-watersport', name: 'Wassersport' },
        { code: 'sbs', icon: 'icon-sport_ball', name: 'Ballsport' },
        { code: 'shb', icon: 'icon-sport_biking', name: 'Hiking / Biking' },
        { code: 'sgl', icon: 'icon-sport_golf', name: 'Golf' },
        { code: 'srd', icon: 'icon-sport_riding', name: 'Reiten' },
        { code: 'sae', icon: 'icon-sport_aerobic', name: 'Aerobic' },
        { code: 'sfr', icon: 'icon-sport_fitness', name: 'Fitnessraum' },
        { code: 'stn', icon: 'icon-sport_tennis', name: 'Tennis' },
        { code: 'sdv', icon: 'icon-sport_diving', name: 'Tauchen' },
        { code: 'sth', icon: 'icon-sport_other', name: 'Sonstiges' },
        { code: 'wel', icon: 'icon-wellness', name: 'Wellness' },
        { code: 'wms', icon: 'icon-wellness_massage', name: 'Massage' },
        { code: 'way', icon: 'icon-wellness_ayurveda', name: 'Ayurveda' },
        { code: 'wth', icon: 'icon-wellness_thalasso', name: 'Thalasso' },
        { code: 'wcu', icon: 'icon-wellness_cure', name: 'Kuranwendung' },
        { code: 'wsn', icon: 'icon-wellness_sauna', name: 'Dampfbad / Sauna' },
        { code: 'wdt', icon: 'icon-diet', name: 'Diät' },
        { code: 'waa', icon: 'icon-wellness_antiaging', name: 'Anti Aging' },
        { code: 'wbf', icon: 'icon-wellness_beautyfarm', name: 'Beauty Farm' },
        { code: 'wac', icon: 'icon-sport_hike', name: 'Aktiv sein' },
        { code: 'wap', icon: 'icon-wellness_akupunktur', name: 'Akupunktur' },
        { code: 'pol', icon: 'icon-pool_outdoor', name: 'Pool' },
        { code: 'ipl', icon: 'icon-pool_indoor', name: 'Hallenbad' },
        { code: 'fin', icon: 'icon-internet_access', name: 'Internetzugang im Haus' },
        { code: 'fwi', icon: 'icon-wlan', name: 'WLAN' },
        { code: 'fwc', icon: 'icon-disabled', name: 'behindertengerecht' },
        { code: 'lcs', icon: 'icon-location_cental', name: 'zentrale Lage' },
        { code: 'rbe', icon: 'icon-separate_bedrooms', name: 'getrennte Schlafzimmer' },
        { code: 'rin', icon: 'icon-room_internet', name: 'Internetzugang im Zimmer' },
        { code: 'rsm', icon: 'icon-smoking_room', name: 'Raucherzimmer' },
        { code: 'rse', icon: 'icon-seaview', name: 'Meerblick' },
        { code: 'krz', icon: 'icon-theme_cruise', name: 'Kreuzfahrten' },
        { code: 'bhn', icon: 'icon-theme_rail', name: 'Bahnreisen' },
        { code: 'bus', icon: 'icon-theme_bus', name: 'Busreisen' },
        { code: 'rdr', icon: 'icon-theme_roundtrip', name: 'Rundreisen' },
        { code: 'cit', icon: 'icon-theme_city', name: 'Städtereisen' },
        { code: 'kur', icon: 'icon-theme_cure', name: 'Kurreisen' },
        { code: 'ski', icon: 'icon-theme_ski', name: 'Skireisen' },
        { code: 'cmp', icon: 'icon-theme_camping', name: 'Camping' },
        { code: 'few', icon: 'icon-theme_fewo', name: 'Ferienwohnungen' },
        { code: 'ado', icon: 'icon-adults_only', name: 'Adults Only' },
        /* {code: "wsl", icon: "", name: "Wasserrutsche"}, */
    ];

    constructor () {
    }

    ngOnInit (): void {
        this.initDatas();
    }

    async initDatas () {
        if (this.data && this.data.length > 0) {
            for (let i = 0; i < this.data.length; i++) {
                for (let j = 0; j < this.keywordList.length; j++) {
                    if (this.data[i] === this.keywordList[j].code) {
                        this.keywords.push(this.keywordList[j]);
                        j = this.keywordList.length;
                    }
                }
            }
        }
    }
}
